import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import './SlideMenu.css';
import menuImage from '../../assets/MariaAdelina3.png';
import logoImage from '../../assets/imagemquinta234.png';
import tapadaImage from '../../assets/Tapada.png';
import villaMenu from '../../assets/VillaMenu.png';
import menuReser from '../../assets/MenuReser.jpg';
import contactMenu from '../../assets/ContactMenu.jpg';
import amostra from '../../assets/amostra.jpg';
import { preloadReservationRequests } from '../../utils/routePreload';

const SlideMenu = ({ isOpen, onClose }) => {
    const { language } = useLanguage();
    const t = translations?.[language] || translations?.pt || {};
    const [hoverImg, setHoverImg] = useState(null);

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('slide-open');
        } else {
            document.body.classList.remove('slide-open');
        }

        return () => {
            document.body.classList.remove('slide-open');
        };
    }, [isOpen]);

    const navigateOrScroll = (target) => {
        // Close the menu first
        if (onClose) onClose();

        // Reset header to top state when navigating to villas
        if (target === 'villas') {
            const header = document.querySelector('.header');
            if (header) {
                header.classList.remove('scrolled');
                // Dispatch custom event to disable scroll detection temporarily
                window.dispatchEvent(new CustomEvent('disableHeaderScrollDetection'));
            }
        }

        // If target looks like a path, navigate to it
        if (typeof target === 'string' && target.startsWith('/')) {
            window.location.href = target;
            return;
        }

        // Otherwise try to scroll to an element id
        const element = document.getElementById(target);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }

        // If the element isn't in the DOM (we're on a different route),
        // navigate to the homepage with a hash so the browser scrolls
        // to the target after navigation.
        window.location.href = `/#${target}`;
    };

    return (
        <div className={`slide-menu ${isOpen ? 'open' : ''}`}>
            <div className="diagonal-lines">
                <div className="line-left"></div>
                <div className="line-right"></div>
            </div>

            <div className="slide-menu-content">
                <img src={menuImage} alt="Aerial view" />
                {/* Hover preview image (appears above background, behind text) */}
                <img
                    src={hoverImg || ''}
                    alt=""
                    className={`hover-image ${hoverImg ? 'visible' : ''}`}
                    aria-hidden="true"
                />
                <div className="text-content">
                    <h2
                        onMouseEnter={() => setHoverImg(tapadaImage)}
                        onMouseLeave={() => setHoverImg(null)}
                        onFocus={() => setHoverImg(tapadaImage)}
                        onBlur={() => setHoverImg(null)}
                        onClick={() => navigateOrScroll('tapada-sao-domingos')}
                        className="clickable-header"
                    >{t.menu.tapada}</h2>

                    <h2
                        onMouseEnter={() => setHoverImg(villaMenu)}
                        onMouseLeave={() => setHoverImg(null)}
                        onFocus={() => setHoverImg(villaMenu)}
                        onBlur={() => setHoverImg(null)}
                        onClick={() => navigateOrScroll('villas')}
                        className="clickable-header"
                    >{t.menu.villas}</h2>

                    <h2
                        onMouseEnter={() => {
                            setHoverImg(menuReser);
                            preloadReservationRequests();
                        }}
                        onMouseLeave={() => setHoverImg(null)}
                        onFocus={() => {
                            setHoverImg(menuReser);
                            preloadReservationRequests();
                        }}
                        onBlur={() => setHoverImg(null)}
                        onClick={() => navigateOrScroll('a-regiao-section')}
                        className="clickable-header"
                    >{t.menu.region}</h2>

                    <h2
                        onMouseEnter={() => setHoverImg(contactMenu)}
                        onMouseLeave={() => setHoverImg(null)}
                        onFocus={() => setHoverImg(contactMenu)}
                        onBlur={() => setHoverImg(null)}
                        onClick={() => navigateOrScroll('/reservations')}
                        className="clickable-header"
                    >{t.menu.reservations}</h2>

                    <h2
                        onMouseEnter={() => setHoverImg(amostra)}
                        onMouseLeave={() => setHoverImg(null)}
                        onFocus={() => setHoverImg(amostra)}
                        onBlur={() => setHoverImg(null)}
                        onClick={() => navigateOrScroll('contactos')}
                        className="clickable-header"
                    >{t.menu.contacts}</h2>
                </div>
            </div>
            <div className="logo-container">
                <img src={logoImage} alt="Logo" className="logo-image" />
            </div>
            <div className="diagonal-lines2">
                <div className="line-left"></div>
                <div className="line-right"></div>
            </div>
        </div>
    );
};

export default SlideMenu;